import type { STPPlan, StpTransactionOrderPayload } from "creso-core/types";
import { api } from "../axios";

export const fetchStpDataById = (
  investmentAccountGuid: string,
  stpId: string
): Promise<STPPlan> => {
  return api.get(`stp/${stpId}/`, {
    params: { investment_account_guid: investmentAccountGuid },
  });
};

export const createStpTransaction = (payload: StpTransactionOrderPayload) => {
  return api.post("stp/", payload);
};

export const deleteStpTransactionApi = ({
  id,
  investment_account_guid,
}: {
  investment_account_guid: string;
  id: number;
}) => {
  return api.delete(`stp/${id}/`, {
    data: {
      investment_account_guid,
    },
  });
};

export const updateStpTransactionApi = ({
  id,
  ...payload
}: StpTransactionOrderPayload & { id: number }) => {
  return api.put(`stp/${id}/`, payload);
};

interface StpStatsResponse {
  total_active_stp_amount: string;
  frequencies: string[];
  active_stp_count: number;
  next_installment_date: string | null;
  total_transferred_amount: string | null;
}

export const getStpStats = (
  investmentAccountId: string
): Promise<StpStatsResponse> => {
  return api.get(`stp/stats/`, {
    params: { investment_account_id: investmentAccountId },
  });
};
